import React, {Component} from "react";
import {connect} from "react-redux";
import {Avatar, Icon} from "antd";
import {userSignOut} from "appRedux/actions/Auth";
import {changeApplication, clearApplications} from "appRedux/actions/Application";

class UserProfile extends Component {
  constructor(props) {
    super(props)

    this.state = {
      name: localStorage.getItem('bms-email') || ''
    };
  }

  render() {

    return (
      <>
        <div className="gx-flex-row gx-align-items-center gx-mb-4 gx-avatar-row">
          <i style={{
            marginRight: '14px',
            fontSize: '24px'
          }} className="icon icon-notification"/>
          <span className="gx-avatar-name">{this.state.name}</span>
        </div>
      </>
    )

  }
}

export default connect(null, {
  userSignOut,
  changeApplication,
  clearApplications
})(UserProfile);
